import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var OpenArrowIcon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.022 11.72a1.728 1.728 0 001.196-.496l8.274-8.275a1.723 1.723 0 00.005-2.44 1.725 1.725 0 00-2.44-.006L10 7.561 2.943.503A1.727 1.727 0 00.508 2.95l8.274 8.275c.33.324.776.502 1.24.495z",
    fill: "currentColor"
  }));
});
OpenArrowIcon.displayName = 'OpenArrowIcon';

export { OpenArrowIcon, OpenArrowIcon as default };
